import React, { useContext } from "react";
import "./App.css";
import cursorDot from "cursor-dot";

//components
import Navbar from "./components/navbar/navbar.component";

//screens
import Introduction from "./screens/introduction/introduction.component";
import About from "./screens/about/about.component";
import Skills from "./screens/skills/skills.component";
import Timeline from "./screens/timeline/timeline.component";
import Projects from "./screens/projects/projects.component";
import Contact from "./screens/contact/contact.component";

import CanvasLayer from "./screens/canvasLayer";
import ReactPageScroller from "react-page-scroller";
import {ThemeContext} from './theme.context';

import { Icon } from "@iconify/react";


function App() {
  const {darkMode} = useContext(ThemeContext);
  return (

      <div className="App" id="top">
  
        <CanvasLayer />
        <div className="root_layer">
          <Navbar />

          <Introduction />
          <About />
          <Skills />
          <Timeline />
          <Projects />
          <Contact />
        </div>
        <a className="up-btn" href="#top">
          <Icon icon="akar-icons:chevron-up" color={darkMode?"white":"#1C2028"} />
        </a>
      </div>
  );
}

export default App;
